import _ from 'lodash'
import MultiTreeSelector from 'scoreboard/components/multi-tree-selector'
import i18n from 'scoreboard/components/i18n'
import DatasetTreeGardener from '../dataset-tree-gardener'
import arrayToHash from 'scoreboard/components/array-to-hash'

/**
 * For setting repeat by groupings (#12826).  The second step of the
 * wizard.  For rollup fields only.  Actually, we decided not to always do
 * rollup breakdowns automatically, so this step is currently not in use.
 */
const SetRepeatByGroupingStep2 = MultiTreeSelector.extend({

	/** @type {Dataset} */
	model: null,

	// this.options.filter is the filter we're working with
	// this.options.new indicates if this is a new filter or not
	// this.options.wizard is the wizard
	// this.options.repeatByType either 'row' or 'column'
	// this.options.grouping the data modified by this filter

	className: 'set-repeat-by-grouping-step2 ' + MultiTreeSelector.prototype.className,

	initialize: function(options) {
		MultiTreeSelector.prototype.initialize.apply(this, arguments)
		this.on('done', function(selections, treeItems) {
			// don't use this.options.wizard.bind(this) b/c we want no arguments
			// passed to the wizard
			this.options.wizard.finish()
		}.bind(this))
	},

	render: function() {
		MultiTreeSelector.prototype.render.apply(this, arguments)
		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
	},

	title: function() {
		return i18n.get('datasets.breakdown.rows')
	},

	createGardener: function() {
		var field = this.model.combinedFieldsById[this.options.grouping.fieldId]
		return new DatasetTreeGardener({
			id: field.treeId,
			showKeys: field.showKeys
		})
	},

	context: function() {
		return {
			title: this.title(),
			treeLabel: i18n.get('datasets.dataType.rollupTree.choose'),
			selectedLabel: i18n.get('datasets.dataType.rollupTree.selected'),
			noneSelectedKey: 'datasets.dataType.rollupTree.selected.none',
			submitLabel: i18n.get('common.done'),
			cascadeHelpKey: 'datasets.dataType.rollupTree.cascade'
		}
	},

	oldSelections: function() {
		return arrayToHash(this.options.grouping.values)
	},

	saveState: function() {
		const grouping = this.options.grouping
		grouping.values = _.keys(this.newSelections())
		this.options.wizard.saveState(grouping)
	}

})

export default SetRepeatByGroupingStep2

SetRepeatByGroupingStep2.__filename__ = 'datasets/overview/set-repeat-by-grouping-step2.js'
